import { render } from "./confirmaciónasistencia.vue?vue&type=template&id=b307a34a&scoped=true"
import script from "./confirmaciónasistencia.vue?vue&type=script&lang=js"
export * from "./confirmaciónasistencia.vue?vue&type=script&lang=js"

import "./confirmaciónasistencia.vue?vue&type=style&index=0&id=b307a34a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b307a34a"]])

export default __exports__